import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ProjectResource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectResource(
    request: Boundaries["editProjectResource"]["request"],
  ): void;
}

function useEditProjectResource(
  projectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectResourceRequestPending(projectResource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectResourceRequestSuccess(projectResource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectResourceRequestFailure(projectResource),
    ),
    editProjectResource: core.editProjectResource,
  };
}

export { useEditProjectResource };
